import request from '@shared/api/request';
import { arrayToFormData } from '@shared/utils/utilsOld';
import axios from 'axios';
import { API_FILES_PATH, API_HISTORY_PATH, API_TEST_CASE_PATH } from '@shared/constants/pathsConstants';
import { formatDateRange } from '@pages/testcases/utils/testcasesUtils';

export function getFileByLink(link) {
    const config = { responseType: 'blob' };
    return axios.get(`${link}`, config);
}

export function getTestCases(params) {
    return request.get(`/${API_TEST_CASE_PATH}/`, {
        params: { ...params, testplan: params?.testplan || params?.testplanId, testplanId: undefined },
    });
}

export function getAllTestCases(moduleName, fields) {
    return request.get(`/${API_TEST_CASE_PATH}/`, {
        params: {
            module: moduleName,
            fields: fields && fields.join(','),
        },
    });
}

export function getTestCaseHistory(id) {
    return request.get(`${API_TEST_CASE_PATH}/${API_HISTORY_PATH}/`, {
        params: {
            id: id,
        },
    });
}

export function getTestCaseCertainRevision(id) {
    return request.get(`${API_TEST_CASE_PATH}/${API_HISTORY_PATH}/details/${id}/`);
}

export function checkoutTestCaseRevision(testcaseId, revisionId) {
    return request.patch(`/${API_TEST_CASE_PATH}/revision/${testcaseId}/${revisionId}/`, {
        history_change_reason: 'Revert testcase',
    });
}

export function getTestCaseById(id) {
    return request.get(`/${API_TEST_CASE_PATH}/${id}/`);
}

export function getTestCaseResults(id, params) {
    const [fromDate, toDate] = formatDateRange(params.dateRange);

    return request.get(`/testrunsresults/`, {
        params: {
            testcase: id,
            page_index: params.pageIndex,
            page_size: params.pageSize,
            status: params.status || undefined,
            testrun__version: params.version || undefined,
            testrun__build: params.build || undefined,
            only_last: params.onlyLast || undefined,
            from: fromDate || undefined,
            to: toDate || undefined,
            created_by_user: params?.user?.pk || undefined,
        },
    });
}

export function getTestCaseResultsAllBuilds(id) {
    return request.get(`${API_TEST_CASE_PATH}/builds/${id}`);
}

export function getFileById(id) {
    return request.get(`/${API_TEST_CASE_PATH}/${API_FILES_PATH}/${id}/`);
}

export function deleteFileById(id) {
    return request.delete(`/${API_TEST_CASE_PATH}/${API_FILES_PATH}/${id}/`);
}

export function editTestCaseAttachments(testcaseId, attachments) {
    let payload = new FormData();
    attachments && arrayToFormData(attachments, payload, 'attachments');

    return request.patch(`/${API_TEST_CASE_PATH}/${testcaseId}/`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function addTestCase(data) {
    return request.post(`/${API_TEST_CASE_PATH}/`, data);
}

export function editTestCase(id, data) {
    return request.patch(`/${API_TEST_CASE_PATH}/${id}/`, data);
}

export function deleteTestCase(id) {
    return request.delete(`/${API_TEST_CASE_PATH}/${id}/`);
}

export function checkForGitTestcase(id) {
    return request.get(`/${API_TEST_CASE_PATH}/${id}/git/`);
}
